import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_HTML, GET_HTML_MSB } from '@/graphql/Mystage/material';
import { SALES_TRIAL_HTML_MATERIAL } from '@/graphql/salesTrial';
import { bizmatesApi } from '@/utils/bizmatesApi';
import { mystageServiceIdHeaderName } from '@/utils/constants';
import logger from '@/modules/Logger';

const fetchTrialHtml = async (params, callback) => {
  const lessonId = params.l;
  const rankId = params.r;
  const k = params.k;
  const v = params.v;
  const serviceId = params.serviceId;
  const client = myStageApolloProvider.defaultClient;

  try {
    const { data } = await client.query({
      query: SALES_TRIAL_HTML_MATERIAL,
      fetchPolicy: 'no-cache',
      variables: {
        lesson_id: parseInt(lessonId),
        rank_id: parseInt(rankId),
        k: String(k),
        v: String(v)
      },
      context: {
        authRequired: false,
        headers: {
          [mystageServiceIdHeaderName]: serviceId
        }
      }
    });

    if (data?.salesTrialHtmlMaterial) {
      callback(data.salesTrialHtmlMaterial);
    } else {
      logger.error('[Materials][HTML] Empty result from trial HTML GraphQL API', {
        operation: 'materials:getHtml',
        event_type: 4,
        lesson_id: lessonId
      });
      callback(false);
    }
  } catch (error) {
    logger.error('[Materials][HTML] Error fetching trial HTML material', {
      error: error.message,
      operation: 'materials:getHtml'
    });
    callback(false);
  }
};

export const GetHtmlService = {
  // Fetch HTML material from MSB GraphQL endpoint
  msb: async (params, callback) => {
    if (params[0].isTrial) return fetchTrialHtml(params[0], callback);

    logger.debug(`[Materials][HTML] Fetching HTML from MSB GraphQL endpoint`, {
      operation: 'materials:get_html',
      params
    });

    const lessonId = params[0].l;
    const rankId = params[0].r;
    const bookingId = params[0].b;
    const studentMaterialId = params[0].sm;
    const client = myStageApolloProvider.defaultClient;

    try {
      const { data } = await client.query({
        query: GET_HTML_MSB,
        fetchPolicy: 'no-cache',
        variables: {
          l: parseInt(lessonId),
          r: parseInt(rankId),
          b: parseInt(bookingId),
          sm: parseInt(studentMaterialId),
          hv: parseInt(params[0]?.hv),
          rv: parseInt(params[0]?.rv),
          s: parseInt(params[0]?.s)
        }
      });

      if (data?.getHtml) {
        callback(data.getHtml);
      } else {
        logger.error(`[Materials][HTML] Empty result from MSB HTML GraphQL API`, {
          operation: 'materials:getHtml',
          event_type: 4,
          lesson_id: lessonId
        });
      }
    } catch (error) {
      logger.error(`[Materials][HTML] Error fetching MSB HTML material`, {
        error: error.message,
        operation: 'materials:getHtml'
      });
      callback(false);
    }
  },
  // Fetch HTML material from mbti GraphQL endpoint
  mbti: async (params, callback) => {
    logger.debug(`[Materials][HTML] Fetching HTML from MBTI GraphQL endpoint`, {
      operation: 'materials:get_html'
    });

    const lessonId = params[0].l;
    const rankId = params[0].r;
    const bookingId = params[0].b;
    const studentMaterialId = params[0].sm;
    const client = apolloProvider.defaultClient;

    try {
      const { data } = await client.query({
        query: GET_HTML,
        fetchPolicy: 'no-cache',
        variables: {
          l: parseInt(lessonId),
          r: parseInt(rankId),
          b: parseInt(bookingId),
          sm: parseInt(studentMaterialId)
        }
      });

      if (data?.get_html) {
        callback(data.get_html);
      } else {
        logger.error(`[Materials][HTML] Empty result from MBTI HTML GraphQL API`, {
          operation: 'materials:get_html',
          event_type: 4,
          lesson_id: lessonId
        });
      }
    } catch (error) {
      logger.error(`[Materials][HTML] Error fetching MBTI HTML material`, {
        error: error.message,
        operation: 'materials:get_html'
      });
      callback(false);
    }
  },

  // Fetch HTML material from legacy REST API
  legacy: async (params, callback) => {
    logger.debug(`[Materials][HTML] Fetching HTML from legacy endpoint`, {
      operation: 'materials:get_html'
    });
    
    await bizmatesApi.get(params[1],  { params: params[0] } , (response) => {
      if (response.data) {
        callback(response.data);
      } else {
        logger.error(`[Materials][HTML] Empty result from legacy HTML API`, {
          operation: 'materials:get_html',
          event_type: 4
        });
      }
    });
  }
};
